import React from 'react';
import { Table, TableBody, TableCell, TableRow, tokens } from '@fluentui/react-components';
import { AlertChip } from '../../../components/Alert/AlertChip';
import { ThreatType } from '../../../components/threat/threat.config'; // Importing ThreatType
import { ScanResultType } from '../../../types';

type ThreatTableProps = {
    items: ScanResultType[];
};

export default function ThreatTable({ items }: ThreatTableProps) {
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Table size="medium" style={{ minWidth: "100%" }}>
                <TableBody>
                    {items.map((item, index) => (
                        <TableRow
                            key={index}
                            style={{
                                backgroundColor: index % 2 === 0 ? tokens.colorNeutralBackground2 : tokens.colorNeutralBackground1,
                                border: "0px solid transparent",
                            }}
                        >
                            <TableCell
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    width: 160,
                                }}
                                title={item?.input_value}
                            >
                                {item?.input_value}
                            </TableCell>
                            <TableCell
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    alignItems: "center",
                                }}
                                title={item?.status}
                            >
                                <div>
                                    <AlertChip
                                        style={{ margin: 0 }}
                                        type={item?.status}
                                        label={item?.status}
                                    />
                                </div>

                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}